export const checkOwner = (formData) => {
  console.log(formData, "checkowner");
  if (formData.staffid?.id == localStorage.getItem("userId")) return "Self";
  return "Other";
};
